import { Avatar, Drawer, Menu, Popover } from "antd";
import { AppLogo, UserAvatar } from "../../assets/svgs";
import { useEffect, useState } from "react";
import styles from "./Header.module.css";
import styled from "@emotion/styled";
import { Input } from "antd";
import { MdKeyboardCommandKey } from "react-icons/md";
import { IoIosMenu } from "react-icons/io";
import { HEADER_MIN_WIDTH } from "../../constant";
import { useLocation, useNavigate } from "react-router-dom";
import { LOGIN } from "../../urlConfig";

const items = [
  {
    label: "Overview",
    key: "/",
  },
  {
    label: "Enterprise",
    key: "/enterprise",
  },
  {
    label: "Candidates",
    key: "/candidate",
  },
  // {
  //   key: "Sales",
  //   label: "sales",
  // },
  // {
  //   key: "Analytics",
  //   label: "analytics",
  // },
  // {
  //   key: "Support",
  //   label: "support",
  // },
  // {
  //   key: "Admin",
  //   label: "admin",
  // },
];

const Header = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("overview");
  const [width, setWidth] = useState(window.innerWidth);
  const [isDrwerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();
  
  const onClick = (e) => {
    console.log("click ", e);
    setCurrent(e.key);
    navigate(e.key)
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, []);

  const CustomMenu = styled(Menu)`
    && .ant-menu-item:hover::after {
      border-bottom: 0px solid transparent;
    }
    && .ant-menu-item:hover {
      color: #ffffff !important;
      opacity: 1 !important;
    }

    && .ant-menu-overflow-item path {
      fill: #ffffff;
      opacity: 1;
    }

    && .ant-menu-item {
      color: #eef6f7;
      opacity: 65% !important;
    }

    && .ant-menu-item-selected {
      border-radius: 4px;
      color: #ffffff !important;
      opacity: 1 !important;
      background: ${width <= HEADER_MIN_WIDTH ? "#7d98ad" : "transparent"};
    }

    && .ant-menu-item-selected:after {
      border-bottom-width: 0px;
      border-bottom-color: transparent;
    }
  `;

  const handleLogout = ()=>{
    sessionStorage.clear()
    navigate(LOGIN)
  }

  const content = (
    <div className={styles.profile_menu}>
      <div onClick={handleLogout}>Logout </div>
    </div>
  );

  return (
    <div className={styles.header_wrap}>
      <div>
        {width <= HEADER_MIN_WIDTH && (
          <IoIosMenu
            onClick={() => setIsDrawerOpen(true)}
            className={styles.menu_icon}
          />
        )}
        <AppLogo />
        {width > HEADER_MIN_WIDTH && (
          <CustomMenu
            className={styles.menu_wrap}
            onClick={onClick}
            selectedKeys={[current]}
            mode="horizontal"
            items={items}
          />
        )}
      </div>
      <div>
        <Input
          placeholder="Search..."
          className={styles.search_bar}
          suffix={
            <div className={styles.search_suffix_wrap}>
              <MdKeyboardCommandKey />T
            </div>
          }
        />
        <Popover content={content} title="" trigger="click">
          <Avatar
            className={styles.avatar_wrap}
            size="large"
            src={<UserAvatar />}
          />
        </Popover>
      </div>
      <Drawer
        title=""
        onClose={() => setIsDrawerOpen(false)}
        open={isDrwerOpen}
        placement={"left"}
        closeIcon={false}
        className={`${styles.drawer_wrap} drawer-content`}
      >
        <CustomMenu
          className={styles.menu_wrap}
          onClick={onClick}
          selectedKeys={[location.pathname]}
          items={items}
        />
      </Drawer>
    </div>
  );
};

export default Header;
